<template>
  <div class="modal-new-topic">
    <form @submit.prevent>
      <h5 class="text-center pb-3 mt-2">
        Criar Tópico
      </h5>

      <form-group
        id="topicTitle"
        v-model="form.title"
        type="text"
        placeholder="Título"
        :errors="errors.title"
        required
      />

      <div id="app" class="my-3">
        <ckeditor :editor="editor" v-model="form.content" required></ckeditor>
      </div>

      <form-group
        id="topicTag"
        v-model="form.tag"
        type="text"
        placeholder="Tags"
        :errors="errors.tag"
        required
      />

      <form-group
        id="topicSelected"
        v-model="form.category"
        select
        :options="options"
        :optionLabelFunction="item => item.title"
        :errors="errors.category"
        type="text"
        placeholder="Categoria"
        required
      />
      <div class="d-flex justify-content-end">
        <button
          class="btn btn-outline-secondary mx-3"
          @click="$emit('close-modal')"
        >
          <h5 class="mb-0">
            Cancelar
          </h5>
        </button>

        <button
          class="btn btn-success btn-publicar"
          type="submit"
          @click="submit"
        >
          <loading :show="isLoading">
            <h5 class="mb-0">
              Publicar
            </h5>
          </loading>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  data() {
    return {
      editor: ClassicEditor,
      idCategory: 0,
      isLoading: false,
      ...formFields(["category", "tag", "content", "title"])
    };
  },
  props: {
    options: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    submit() {
      if (!this.form.title.length) {
        this.errors.title = ["Este campo é obrigatório!"];
        return;
      }
      if (!this.form.content.length) {
        this.errors.content = ["Este campo é obrigatório!"];
        return;
      }
      if (!this.form.tag.length) {
        this.errors.tag = ["Este campo é obrigatório!"];
        return;
      }
      if (this.form.category == 0) {
        this.errors.category = ["Este campo é obrigatório!"];
        return;
      }

      this.isLoading = true;

      this.$store
        .dispatch("forum/createTopic", {
          title: this.form.title,
          content: this.form.content,
          tags: this.form.tag.trim().split(" "),
          category: this.form.category
        })
        .then(() => {
          this.$emit("refresh");
          this.$message.success("Tópico criado com sucesso");
        })
        .catch(() => {
          this.$message.error("Não foi possível criar seu tópico.");
        })
        .finally(() => {
          this.isLoading = false;
          this.$emit("close-modal");
        });
    }
  }
};
</script>

<style lang="scss">
.modal-new-topic {
  .ck,
  .ck-sticky-panel__content {
    background: #000 !important;
    border-radius: 8px 8px 0 0 !important;
  }
  .ck-icon,
  .ck-button,
  .ck-labeled-field-view__status {
    color: #fff !important;
  }
  .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
    border-top: none;
    border-radius: 0 0 8px 8px !important;
  }
}
</style>
